{
  "decrease": "Zmniejsz {fieldLabel}",
  "increase": "Zwiększ {fieldLabel}",
  "numberField": "Pole numeru"
}
